import { Icon, makeStyles, useTheme } from '@rneui/themed'
import React from 'react'
import { View } from 'react-native'
import { DropdownItem, DropdownSection } from 'shared/components/dropdown'

interface Props<Item extends DropdownItem> {
  sections: DropdownSection<Item>[]
  selectedId: any
  onSelect: (id: any) => void
  children: React.ReactElement
}

export function SideStepButtons<Item extends DropdownItem = DropdownItem>({
  selectedId,
  sections,
  children,
  onSelect,
}: Props<Item>) {
  const storeIds: string[] = sections.flatMap(section =>
    section.data.map(m => m.id)
  )
  const selectedIdIndex = storeIds.findIndex(item => item === selectedId)
  const styles = useStyles()
  const { theme } = useTheme()
  const leftDisabled = selectedIdIndex === 0
  const rightDisabled = selectedIdIndex === storeIds.length - 1

  if (storeIds.length <= 1) {
    return <>{children}</>
  }

  return (
    <View style={styles.container}>
      <Icon
        onPress={() =>
          selectedIdIndex > 0 && onSelect(storeIds[selectedIdIndex - 1])
        }
        iconStyle={styles.sideStepIcon}
        type="font-awesome-5"
        solid
        name="caret-left"
        size={17}
        color={leftDisabled ? theme.colors?.disabled : theme.colors?.primary}
        disabled={leftDisabled}
        disabledStyle={{ backgroundColor: 'transparent' }}
      />
      {children}
      <Icon
        onPress={() =>
          selectedIdIndex < storeIds.length - 1 &&
          onSelect(storeIds[selectedIdIndex + 1])
        }
        iconStyle={styles.sideStepIcon}
        type="font-awesome-5"
        solid
        name="caret-right"
        size={17}
        color={rightDisabled ? theme.colors?.disabled : theme.colors?.primary}
        disabled={rightDisabled}
        disabledStyle={{ backgroundColor: 'transparent' }}
      />
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  sideStepIcon: {
    justifyContent: 'center',
    marginHorizontal: 7,
  },
}))
